"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeIdToken = exports.UserManager = void 0;
var _jwtDecode = require("jwt-decode");
var _oidcClientTs = require("oidc-client-ts");
var _utils = require("../../utils");
var _singleSignOut = require("../singleSignOut");
class _UserManager extends _oidcClientTs.UserManager {
  signInCallback(url) {
    return this.signinCallback(url);
  }
  signInRedirect(args) {
    return this.signinRedirect(args);
  }
  signInRedirectCallback(url) {
    return this.signinRedirectCallback(url);
  }
  signInSilent(args) {
    return this.signinSilent(args);
  }
  signInSilentCallback(url) {
    return this.signinSilentCallback(url);
  }
  signInPopup(args) {
    return this.signinPopup(args);
  }
  signInPopupCallback(url, keepOpen) {
    return this.signinPopupCallback(url, keepOpen);
  }
  signOutRedirect(args) {
    return this.signoutRedirect(args);
  }
  signOutRedirectCallback(url) {
    return this.signoutRedirectCallback(url);
  }
  signOutPopup(args) {
    return this.signoutPopup(args);
  }
  signOutPopupCallback(url, keepOpen) {
    return this.signoutPopupCallback(url, keepOpen);
  }
  async signOutCallback(url, keepOpen) {
    const res = await this.signoutCallback(url, keepOpen);
    (0, _singleSignOut.propagateLogout)();
    return res;
  }
}
class UserManager extends (0, _utils.Omit)(_UserManager, ["signinCallback", "signinRedirect", "signinRedirectCallback", "signinSilent", "signinSilentCallback", "signinPopup", "signinPopupCallback", "signoutCallback", "signoutRedirect", "signoutRedirectCallback", "signoutPopup", "signoutPopupCallback"]) {}
exports.UserManager = UserManager;
const decodeIdToken = idToken => (0, _jwtDecode.jwtDecode)(idToken);
exports.decodeIdToken = decodeIdToken;
//# sourceMappingURL=index.js.map